import React, { useState } from "react";
import "../Styles/CurrentJobs.css";
import { FaMapMarkerAlt, FaClock, FaMoneyBillWave, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CurrentJobsregister from "../components/CurrentJobsregister";
import defaultLogo from "../assets/logo2.png";

const CurrentJobs = () => {
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  /* =
     STATIC JOB DATA (localStorage removed)
  == */
  const jobs = [
    {
      id: 1,
      title: "Software Developer",
      companyname: "Tech Solutions Pvt Ltd",
      salaryMin: "4",
      salaryMax: "7",
      skills: ["React", "Node.js", "MongoDB"],
      qualification: "B.Tech / B.E in CSE or related field",
      location: "Hyderabad, Telangana",
      experienceMin: "1",
      experienceMax: "3",
      attachment: defaultLogo,
    },
    {
      id: 2,
      title: "Field Coordinator",
      companyname: "Rural Development Trust",
      salaryMin: "2.5",
      salaryMax: "4",
      skills: ["Communication", "MS Office", "Local Language Fluency"],
      qualification: "Any Degree",
      location: "Kandukur, Andhra Pradesh",
      experienceMin: "0",
      experienceMax: "2",
      attachment: defaultLogo,
    },
  ];

  /* =
     APPLY HANDLER (POPUP)
  == */
  const openPopup = (job) => {
    setSelectedJob(job); // future use after login
    setShowPopup(true);
  };

  const closePopup = () => {
    setSelectedJob(null);
    setShowPopup(false);
  };

  return (
    <div className="jobs-section" id="current">
      {/* HEADER */}
      <div className="jobs-header">
        <h2 className="jobs-title">CURRENT JOBS</h2>

        <button
          className="current-view-all-btn"
          onClick={() => navigate("/Currentjobsview/")}
        >
          View All <FaArrowRight />
        </button>
      </div>

      {/* JOB LIST */}
      <div className="jobs-grid">
        {jobs.length > 0 ? (
          jobs.slice(0, 2).map((job) => (
            <div key={job.id} className="job-card">
              <div className="job-details">
                <div className="main-hed">
                  <div>
                    <h3>{job.title}</h3>

                    <p className="job-meta">
                      <FaMoneyBillWave className="icon-l" />
                      {job.salaryMin && job.salaryMax
                        ? ` ₹${job.salaryMin} - ₹${job.salaryMax} LPA`
                        : " - LPA"}
                    </p>

                    <p>
                      <strong>Company:</strong>{" "}
                      {job.companyname || job.company}
                    </p>
                  </div>

                  <div className="job-image-wrapper">
                    <img
                      src={job?.attachment || defaultLogo}
                      alt={job?.title || "Company Logo"}
                      className="job-image"
                    />
                  </div>
                </div>

                <div className="currnt-cont">
                  <div className="m-2">
                    <p className="clamp-text">
                      <strong>Skills:</strong>{" "}
                      {Array.isArray(job.skills)
                        ? job.skills.join(", ")
                        : job.skills || "-"}
                    </p>

                    <p className="clamp-text">
                      <strong>Qualification:</strong>{" "}
                      {job.qualification || "-"}
                    </p>
                  </div>

                  <div className="m-2 ms-5">
                    <p>
                      <FaMapMarkerAlt className="icon-l" />{" "}
                      {job.location || job.jobLocation}
                    </p>

                    <p>
                      <FaClock className="icon-l" />{" "}
                      {job.experienceMin
                        ? `${job.experienceMin}-${job.experienceMax} Years`
                        : job.exp || "-"}
                    </p>
                  </div>
                </div>

                <div className="current-btn">
                  <button
                    className="apply-btn"
                    onClick={() => openPopup(job)}
                  >
                    APPLY NOW
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center mt-4">
            No jobs available right now
          </p>
        )}
      </div>

      {/* LOGIN / MEMBERSHIP POPUP */}
      <CurrentJobsregister
        show={showPopup}
        onClose={closePopup}
        job={selectedJob}
      />
    </div>
  );
};

export default CurrentJobs;